// Library Methods
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";

// Components
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import ReportLayoutDropdown from "../../shared/ReportLayoutDropdown/ReportLayoutDropdown";
import {
  MultiplePagesODIcon,
  MultiplePagesOSIcon,
  SinglePageODIcon,
  SinglePageOSIcon,
} from "src/assets/icons";
import Alert from "src/components/shared/alerts/Alert/Alert";

// Styles
import { getSurfaceTokens } from "src/styles/mui/muiStylesHelper";

// Contexts
import { useClinicSettingsContext } from "src/contexts/clinic/ClinicSettingsContext";
import { useClinicContext } from "src/contexts/clinic/ClinicProvider";

const ReportLayoutSetup = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { mutedText: mutedTextColor } = getSurfaceTokens(theme);
  const { clinicInfo } = useClinicContext();
  const { currentSettings, handleUpdateSettings, isLoading, isUpdating } =
    useClinicSettingsContext();

  const canUseExamPackaging = clinicInfo?.licensing?.canUseExamPackaging;

  return (
    <Box display="flex" flexDirection="column" gap="6px">
      <Typography fontSize="14px" fontWeight={600}>
        {t("Monocular Report PDF Layout")}
      </Typography>
      {canUseExamPackaging ? (
        <Alert
          variant="warning"
          alertContent={`${t("For multi-exam packages, exams of the same type will always appear on the same page.")}`}
        />
      ) : (
        <Alert
          alertContent={t(
            "This setting applies to report PDFs for exams of the same type."
          )}
        />
      )}
      <Typography fontSize="14px" color={mutedTextColor} mb="10px">
        {t("Controls the layout of monocular report PDFs.")}
      </Typography>

      <Box display="flex" justifyContent="space-around" my="8px">
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap="8px"
          color={mutedTextColor}
        >
          {clinicInfo?.settings?.reportDisplayLeftEyeFirst ? (
            <SinglePageOSIcon />
          ) : (
            <SinglePageODIcon />
          )}
          <Typography fontSize="14px" color={mutedTextColor}>
            {t("Single Page")}
          </Typography>
        </Box>

        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap="8px"
          color={mutedTextColor}
        >
          {clinicInfo?.settings?.reportDisplayLeftEyeFirst ? (
            <MultiplePagesOSIcon />
          ) : (
            <MultiplePagesODIcon />
          )}
          <Typography fontSize="14px" color={mutedTextColor}>
            {t("Multiple Pages")}
          </Typography>
        </Box>
      </Box>
      <ReportLayoutDropdown
        isDisabled={isLoading || isUpdating}
        currentSettings={currentSettings}
        handleUpdateSettings={handleUpdateSettings}
      />
    </Box>
  );
};

export default ReportLayoutSetup;
